// extracted by mini-css-extract-plugin
export var measureBox = "_c7-0";